import { useEffect } from 'react'
import { useBlocker } from 'react-router-dom'
import { hasBackHandler, runTopBackHandler } from '@/lib/navigation/back-handlers'

export function useOverlayBackGuard() {
  const blocker = useBlocker(({ historyAction }) => historyAction === 'POP' && hasBackHandler())

  useEffect(() => {
    if (blocker.state !== 'blocked') {
      return
    }
    if (runTopBackHandler()) {
      blocker.reset()
      return
    }
    blocker.proceed()
  }, [blocker])
}
